module.exports = __webpack_public_path__ + "img/partypopper-emoji.d86c37d.png";